import styled from 'styled-components';

import { media } from '@/Shared/theme';
import FeatherBackground from '@/components/FeatherBackground';

export const StyledBG = styled.div`
	align-items: center;
	background-color: var(--c-white);
	background: linear-gradient(45deg, rgb(145 144 180 / 20%), var(--c-white));
	display: flex;
	flex-direction: column;
	height: 100vh;
	justify-content: center;
	overflow: hidden;
	padding: var(--spacing-6);
	position: relative;
	width: 100%;

	.logo {
		margin-bottom: var(--spacing-8);
		margin-top: auto;
		width: 200px;
	}
`;

export const StyledForm = styled.form`
	display: flex;
	flex-flow: column;
	margin-bottom: auto;
	max-width: 380px;
	position: relative;
	width: 100%;

	div {
		flex: 0 0 auto;
		margin-right: 0;
		max-width: none;
	}

	input {
		margin-bottom: var(--spacing-4);
		max-width: none;

		&[type='password'] {
			margin-bottom: var(--spacing-4);
		}
	}

	.error-message {
		margin-bottom: var(--spacing-4);
		margin-top: calc(var(--spacing-4) * -1);
	}

	label {
		color: var(--body-text);
		font-size: 1.4rem;
		user-select: none;
	}

	input[type='checkbox'] + label {
		color: var(--label-text);
	}

	input[type='checkbox'] {
		margin-bottom: 0;
	}

	span {
		align-self: flex-start;
	}
`;

export const StyledFormFooter = styled.div`
	display: flex;
	align-items: center;
	flex-flow: row wrap;
	justify-content: space-between;
	margin-bottom: var(--spacing-4);

	button[type='submit'] {
		width: 125px;
	}

	a {
		color: var(--body-text);
		margin: var(--spacing-4) 0;
		text-align: center;
		text-decoration: none;
	}
`;

export const StyledFeatherBackgroundTop = styled(FeatherBackground)`
	display: none;

	${media.smallScreen} {
		display: block;
		max-width: 560px;
		opacity: 0.5;
		position: absolute;
		right: -80px;
		top: -80px;
		width: 100%;
	}
`;

export const StyledFeatherBackgroundBottom = styled(FeatherBackground)`
	bottom: -80px;
	left: -80px;
	max-width: 560px;
	opacity: 0.5;
	position: absolute;
	width: 100%;
`;

export const StyledCopy = styled.span`
	color: var(--body-text);
	font-size: 1rem;
	margin-left: auto;
	margin-top: auto;
`;
